module.exports = __webpack_public_path__ + "img/valance-roman.68959576.svg";